// @flow
import { useParams } from 'react-router-dom';
import React, { useCallback, useMemo } from 'react';

import { DataFetcherContainer } from '../components/presentational/DataFetcherContainer';
import { useGetNativeInferencePoolQuery } from '../service-definitions/estimates';

import { NativeInferencePoolContext } from './NativeInferencePoolContext';

export const NativeInferencePoolContextProvider = ({ children }) => {
  const { estimateId, nativeInferencePoolId } = useParams();

  return (
    <DataFetcherContainer
      dataFetchingArgs={useMemo(
        () => [
          { estimateId: estimateId, nativeInferencePoolId: nativeInferencePoolId },
          {
            skip: !estimateId || !nativeInferencePoolId,
          },
        ],
        [nativeInferencePoolId, estimateId]
      )}
      dataFetchingFunction={useCallback(useGetNativeInferencePoolQuery, [])}
    >
      {(data) => {
        return (
          <NativeInferencePoolContext.Provider value={data}>
            {children}
          </NativeInferencePoolContext.Provider>
        );
      }}
    </DataFetcherContainer>
  );
};
